export default {"src":"/_next/static/media/Diabetes and Pre-Diabetes.3ed5a73a.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};